/* iPhone Pluggz storefront behaviour */
(function () {
  var PZ = window.PZ || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); };
  var money = function (c) { var v = c / 100; return 'R ' + v.toLocaleString('en-US', { minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 }); };
  var svg = function (d, s) { return '<svg width="' + (s || 24) + '" height="' + (s || 24) + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + d + '</svg>'; };
  var ICON = {
    trash: svg('<path d="M3 6h18M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2M10 11v6M14 11v6"/>', 20),
    refresh: svg('<path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8M21 3v5h-5M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16M8 16H3v5"/>', 24),
    arrow: svg('<path d="M5 12h14M12 5l7 7-7 7"/>', 20),
    chev: svg('<path d="m9 18 6-6-6-6"/>', 20),
    wa: '<svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/></svg>',
    shield: svg('<path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/><path d="m9 12 2 2 4-4"/>', 24),
    truck: svg('<path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2M15 18H9M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.62l-3.48-4.35A1 1 0 0 0 17.52 8H14"/><circle cx="17" cy="18" r="2"/><circle cx="7" cy="18" r="2"/>', 24),
    box: svg('<path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8M21 3v5h-5M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16M8 16H3v5"/>', 24),
    card: svg('<path d="M21 7.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3.5M16 2v4M8 2v4M3 10h5"/><circle cx="16" cy="16" r="6"/><path d="M16 14v2l1 1"/>', 24),
    heart: svg('<path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/>', 40),
    tag: svg('<path d="M12.59 2.59A2 2 0 0 0 11.17 2H4a2 2 0 0 0-2 2v7.17a2 2 0 0 0 .59 1.42l8.7 8.7a2.43 2.43 0 0 0 3.42 0l6.58-6.58a2.43 2.43 0 0 0 0-3.42z"/><circle cx="7.5" cy="7.5" r="1" fill="currentColor"/>', 18)
  };
  var badgeMap = { 'brand new': ['new', 'Brand New'], 'grade a': ['a', 'Grade A'], 'grade b': ['b', 'Grade B'], 'grade c': ['c', 'Grade C'] };
  var FIN_FT_MIN = 600000;
  function finForce(tags) {
    var t = (tags || []).map(function (x) { return String(x).toLowerCase(); });
    return t.indexOf('finance:payjustnow') > -1 ? 'pjn' : t.indexOf('finance:fevertree') > -1 ? 'ft' : '';
  }
  var pjnLogoCache = null;
  function finHtml(cents, force) {
    var showFt = cents >= FIN_FT_MIN || force === 'ft';
    if (force === 'pjn') showFt = false;
    var out = '<div class="pz-fincompact" data-force="' + (force || '') + '">';
    out += '<div class="pz-fincompact__row"><span class="pz-plogo pz-plogo--pj" role="img" aria-label="PayJustNow">' + (pjnLogoCache || '') + '</span><span class="pz-fincompact__amt">3 &times; ' + money(Math.round(cents / 3)) + '</span></div>';
    if (showFt) {
      out += '<div class="pz-fincompact__row"><span class="pz-plogo pz-plogo--ft" role="img" aria-label="FeverTree Finance"></span><span class="pz-fincompact__amt">' + money(Math.round(cents / 1200) * 100) + ' / month</span></div>';
    }
    out += '</div>';
    return out;
  }
  function finBoxHtml(cents, force) {
    var href = PZ.fever || '/pages/fevertree-payments';
    var showFt = cents >= FIN_FT_MIN || force === 'ft';
    if (force === 'pjn') showFt = false;
    var pjnAmt = money(Math.round(cents / 3));
    var ftAmt = money(Math.round(cents / 1200) * 100);
    var out = '<div class="pz-finboxes pz-finboxes--lg' + (showFt ? '' : ' pz-finboxes--one') + '" data-force="' + (force || '') + '">';
    out += '<a class="pz-finbox pz-finbox--pjn" href="' + href + '#payjustnow"><span class="pz-plogo pz-plogo--pj" role="img" aria-label="PayJustNow">' + (pjnLogoCache || '') + '</span><b>' + pjnAmt + ' / payment</b><small>3 monthly instalments, interest-free</small></a>';
    if (showFt) {
      out += '<a class="pz-finbox pz-finbox--ft" href="' + href + '"><span class="pz-plogo pz-plogo--ft" role="img" aria-label="FeverTree Finance"></span><b>' + ftAmt + ' / month</b><small>12 monthly payments, interest-free</small></a>';
    }
    out += '</div>';
    return out;
  }

  function toast(msg, action) {
    var t = document.createElement('div');
    t.setAttribute('role', 'status');
    t.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);background:#0c0c0e;color:#fff;padding:12px 18px;border-radius:12px;z-index:200;font-size:14px;box-shadow:0 10px 30px rgba(0,0,0,.25);display:flex;gap:14px;align-items:center;max-width:calc(100vw - 32px)';
    t.appendChild(document.createTextNode(msg));
    if (action) {
      var b = document.createElement('button');
      b.type = 'button'; b.textContent = action.label;
      b.style.cssText = 'background:none;border:0;color:#7fb2ff;font:inherit;font-weight:700;padding:4px;cursor:pointer';
      b.addEventListener('click', function () { action.fn(); t.remove(); });
      t.appendChild(b);
    }
    document.body.appendChild(t); setTimeout(function () { t.remove(); }, 3600);
  }

  function rotator(el) {
    var slides = $$('[data-slide]', el), dots = $$('[data-dots] button', el), i = 0, t;
    if (slides.length < 2) return;
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
    }
    function run() { clearInterval(t); t = setInterval(function () { go(i + 1); }, +el.dataset.speed || 5000); }
    $$('[data-dir]', el).forEach(function (b) { b.addEventListener('click', function () { go(i + +b.dataset.dir); run(); }); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); run(); }); });
    el.addEventListener('mouseenter', function () { clearInterval(t); });
    el.addEventListener('mouseleave', run);
    run();
  }
  $$('[data-pz-rot]').forEach(rotator);

  var hd = $('[data-pz-header]');
  if (hd) {
    var over = hd.dataset.over === 'true';
    var sync = function () { hd.classList.toggle('is-solid', !over || window.scrollY > 24); };
    sync(); window.addEventListener('scroll', sync, { passive: true });
  }

  var back = $('[data-pz-back]');
  function closeAll() {
    $$('[data-pz-panel].is-open').forEach(function (p) { p.classList.remove('is-open'); p.setAttribute('aria-hidden', 'true'); });
    if (back) back.classList.remove('is-on');
    document.documentElement.classList.remove('pz-lock');
  }
  function openPanel(name) {
    var p = $('[data-pz-panel="' + name + '"]');
    if (!p) return false;
    closeAll();
    p.classList.add('is-open'); p.setAttribute('aria-hidden', 'false');
    if (back) back.classList.add('is-on');
    document.documentElement.classList.add('pz-lock');
    if (name === 'search') { var inp = $('input', p); if (inp) setTimeout(function () { inp.focus(); }, 250); }
    if (name === 'wishlist') renderWish();
    return true;
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeAll(); var lb = $('.pz-lb'); if (lb) lb.classList.remove('is-on'); } });

  var api = {
    get: function () { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); },
    add: function (id, qty, props) {
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +id, quantity: qty || 1, properties: props || undefined }] }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); return j; }); });
    },
    change: function (line, qty) {
      return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok || !j || !j.items) throw new Error((j && (j.description || j.message)) || 'Could not update your cart'); return j; }); });
    }
  };
  function waLink(text) { return (PZ.wa || 'https://wa.me/27628067440?text=') + encodeURIComponent(text); }
  function cartHasPromo(c) {
    var ids = PZ.promoIds;
    if (!ids || !ids.length) return false;
    return c.items.some(function (it) { return ids.indexOf(String(it.product_id)) > -1; });
  }
  function cartHTML(c) {
    var shop = PZ.shop || '/collections/shop-iphones';
    if (!c.item_count) {
      return '<div class="pz-empty"><h3>Your cart is empty</h3><p>Find your next device, or ask us on WhatsApp.</p><a class="pz-btn" href="' + shop + '">Shop iPhones ' + ICON.arrow + '</a></div>';
    }
    var lines = c.items.map(function (it, k) {
      var img = it.image ? '<a class="pz-line__img" href="' + esc(it.url) + '"><img src="' + esc(it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=240') + '" alt="' + esc(it.product_title) + '" loading="lazy"></a>' : '<span class="pz-line__img"></span>';
      var tags = '';
      if (it.properties) {
        var m = it.properties.Condition ? badgeMap[String(it.properties.Condition).toLowerCase()] : null;
        if (m) tags += '<span class="pz-badge pz-badge--' + m[0] + '">' + m[1] + '</span>';
        if (it.properties['Battery Health']) tags += '<span>Battery Health: ' + esc(it.properties['Battery Health']) + '</span>';
      }
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<div class="pz-line__v">' + esc(it.variant_title) + '</div>' : '';
      return '<li class="pz-line">' + img + '<div><a class="pz-line__t" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + variant + (tags ? '<div class="pz-line__tags">' + tags + '</div>' : '') +
        '<div class="pz-line__p">' + money(it.final_line_price) + (it.quantity > 1 ? ' <span class="pz-line__each">' + money(it.final_price) + ' each</span>' : '') + '</div>' + finHtml(it.final_line_price) +
        '<div class="pz-line__row"><div class="pz-qty"><button type="button" data-line="' + (k + 1) + '" data-qty="' + (it.quantity - 1) + '" aria-label="Decrease quantity">−</button><span>' + it.quantity + '</span><button type="button" data-line="' + (k + 1) + '" data-qty="' + (it.quantity + 1) + '" aria-label="Increase quantity">+</button></div>' +
        '<button type="button" class="pz-rm" data-line="' + (k + 1) + '" data-qty="0" aria-label="Remove ' + esc(it.product_title) + '">' + ICON.trash + '</button></div></div></li>';
    }).join('');
    var msg = 'Hi iPhone Pluggz, I would like to chat about my order:\n' + c.items.map(function (i) { return i.quantity + 'x ' + i.product_title + (i.variant_title && i.variant_title !== 'Default Title' ? ' (' + i.variant_title + ')' : '') + ' - ' + money(i.final_line_price); }).join('\n') + '\nTotal: ' + money(c.total_price);
    return '<div class="pz-cartpad"><ul class="pz-lines">' + lines + '</ul>' +
      '<a class="pz-tin" style="margin-top:18px" href="' + (PZ.tradein || '#') + '"><span style="color:var(--pz-ink);display:flex">' + ICON.refresh + '</span><div><b>Have a device to trade in?</b><span>Get a better price on your next device.</span></div>' + ICON.chev + '</a>' +
      '<div class="pz-sum"><h3>Order summary</h3>' +
      (cartHasPromo(c) ? '<button type="button" class="pz-promo" data-pz-copy="SAVE500">' + ICON.tag + '<span>R500 off with code <b>SAVE500</b> (cash or upfront payment only, not valid with financing)</span><span class="pz-promo__copy">Copy</span></button>' : '') +
      '<div class="pz-sum__t"><span>Subtotal (' + c.item_count + ' item' + (c.item_count > 1 ? 's' : '') + ')</span><span>' + money(c.total_price) + '</span></div>' + finHtml(c.total_price) +
      '<div class="pz-sum__r"><span>Delivery</span><span>Calculated at checkout</span></div>' +
      '<div class="pz-cta"><a class="pz-btn pz-btn--block" href="/checkout">Checkout ' + ICON.arrow + '</a>' +
      '<a class="pz-btn pz-btn--wa pz-btn--block" target="_blank" rel="noopener" href="' + waLink(msg) + '">' + ICON.wa + ' Ask us on WhatsApp</a></div></div>' +
      '<div class="pz-mini"><div>' + ICON.shield + '<span>Secure<br>checkout</span></div><div>' + ICON.truck + '<span>Nationwide<br>delivery</span></div><div>' + ICON.box + '<span>7-day<br>returns</span></div><div>' + ICON.card + '<span>Pay<br>monthly</span></div></div></div>';
  }
  function paint(c) {
    $$('[data-pz-count]').forEach(function (b) { b.textContent = c.item_count; b.dataset.n = c.item_count; });
    $$('[data-pz-cart-body]').forEach(function (b) { b.innerHTML = cartHTML(c); });
    $$('[data-pz-cart-upsell]').forEach(function (b) { b.style.display = c.item_count ? '' : 'none'; });
  }
  function refresh() { return api.get().then(function (c) { paint(c); return c; }); }
  refresh();
  function addToCart(id, props, btn) {
    if (btn) btn.disabled = true;
    return api.add(id, 1, props).then(refresh).then(function () { if (!openPanel('cart')) location.href = '/cart'; })
      .catch(function (e) { toast(e.message); })
      .then(function () { if (btn) btn.disabled = false; });
  }

  var WKEY = 'pz-wish', wcache = {};
  function wget() { try { return JSON.parse(localStorage.getItem(WKEY) || '[]'); } catch (e) { return []; } }
  function wset(l) { try { localStorage.setItem(WKEY, JSON.stringify(l)); } catch (e) { } }
  function wsync() {
    var l = wget();
    $$('[data-pz-wish]').forEach(function (w) { var on = l.indexOf(w.dataset.pzWish) > -1; w.classList.toggle('is-on', on); w.setAttribute('aria-pressed', on); });
    $$('[data-pz-wcount]').forEach(function (b) { b.textContent = l.length; b.dataset.n = l.length; });
    var p = $('[data-pz-panel="wishlist"]'); if (p && p.classList.contains('is-open')) renderWish();
  }
  function wtoggle(h) {
    var l = wget(), i = l.indexOf(h);
    if (i > -1) l.splice(i, 1); else l.push(h);
    wset(l); wsync();
    if (i === -1) toast('Saved to your wishlist', { label: 'View', fn: function () { openPanel('wishlist'); } });
  }
  function wproduct(h) {
    if (wcache[h]) return Promise.resolve(wcache[h]);
    return fetch('/products/' + encodeURIComponent(h) + '.js').then(function (r) { if (!r.ok) throw 0; return r.json(); }).then(function (p) { wcache[h] = p; return p; }).catch(function () { return null; });
  }
  function renderWish() {
    var body = $('[data-pz-wish-body]'); if (!body) return;
    var l = wget();
    if (!l.length) {
      body.innerHTML = '<div class="pz-empty"><span style="color:var(--pz-mute);display:flex;justify-content:center">' + ICON.heart + '</span><h3>Your wishlist is empty</h3><p>Tap the heart on any product to save it here for later.</p><a class="pz-btn" href="' + (PZ.shop || '/collections/all') + '">Browse iPhones ' + ICON.arrow + '</a></div>';
      return;
    }
    body.innerHTML = '<div class="pz-cartpad" style="padding-block:6px"><p class="pz-sub" style="margin:10px 0 0">' + l.length + ' saved item' + (l.length > 1 ? 's' : '') + '</p></div><div class="pz-cartpad"><ul class="pz-lines" data-pz-wlist></ul></div>';
    var ul = $('[data-pz-wlist]', body);
    Promise.all(l.map(wproduct)).then(function (ps) {
      ul.innerHTML = ps.map(function (p, k) {
        if (!p) return '';
        var img = p.featured_image ? '<a class="pz-line__img" href="' + esc(p.url) + '"><img src="' + esc(p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=240') + '" alt="' + esc(p.title) + '" loading="lazy"></a>' : '<span class="pz-line__img"></span>';
        var one = p.variants.length === 1;
        var action = !p.available ? '<span class="pz-stock pz-stock--out">Sold out</span>' : one ? '<button type="button" class="pz-btn pz-btn--sm" data-pz-add data-id="' + p.variants[0].id + '">Add to cart</button>' : '<a class="pz-btn pz-btn--sm" href="' + esc(p.url) + '">Choose options</a>';
        return '<li class="pz-line">' + img + '<div><a class="pz-line__t" href="' + esc(p.url) + '">' + esc(p.title) + '</a><div class="pz-line__p">' + money(p.price) + '</div>' + finHtml(p.price, finForce(p.tags)) +
          '<div class="pz-line__row">' + action + '<button type="button" class="pz-rm" data-pz-wish="' + esc(l[k]) + '" aria-label="Remove ' + esc(p.title) + ' from wishlist">' + ICON.trash + '</button></div></div></li>';
      }).join('');
    });
  }
  window.addEventListener('storage', function (e) { if (e.key === WKEY) wsync(); });
  wsync();

  document.addEventListener('click', function (e) {
    var t = e.target;
    var o = t.closest('[data-pz-open]');
    if (o) {
      var name = o.dataset.pzOpen;
      if (name === 'cart' && $('[data-pz-cartpage]')) return;
      if (openPanel(name)) e.preventDefault();
      return;
    }
    if (t.closest('[data-pz-close]') || t === back) { closeAll(); return; }
    var a = t.closest('[data-pz-add]');
    if (a) {
      e.preventDefault();
      var props = null; try { props = a.dataset.props ? JSON.parse(a.dataset.props) : null; } catch (x) { }
      addToCart(a.dataset.id, props, a); return;
    }
    var q = t.closest('[data-qty]');
    if (q) {
      if (q.disabled) return;
      var box = q.closest('.pz-line') || q; box.classList.add('is-busy');
      $$('[data-qty]', box).forEach(function (b) { b.disabled = true; });
      api.change(+q.dataset.line, +q.dataset.qty).then(paint).catch(function (err) { toast(err.message); refresh(); });
      return;
    }
    var cp = t.closest('[data-pz-copy]');
    if (cp) {
      e.preventDefault();
      var code = cp.dataset.pzCopy;
      var done = function () { toast('Code copied — paste it at checkout'); };
      var legacyCopy = function () {
        var ok = false;
        try {
          var ta = document.createElement('textarea');
          ta.value = code; ta.setAttribute('readonly', ''); ta.style.cssText = 'position:fixed;top:-1000px;left:-1000px';
          document.body.appendChild(ta); ta.focus(); ta.select();
          ok = !!(document.execCommand && document.execCommand('copy'));
          ta.remove();
        } catch (x) { ok = false; }
        if (ok) done(); else toast('Code: ' + code);
      };
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(code).then(done).catch(legacyCopy); }
        else { legacyCopy(); }
      } catch (x) { legacyCopy(); }
      return;
    }
    var w = t.closest('[data-pz-wish]');
    if (w) { e.preventDefault(); wtoggle(w.dataset.pzWish); return; }
    var sc = t.closest('[data-pz-scroll]');
    if (sc) {
      var box = sc.closest('[data-pz-scrollwrap]'), s = box && $('.pz-scroller,.pz-rail', box);
      if (s) s.scrollBy({ left: +sc.dataset.pzScroll * Math.max(260, s.clientWidth * .8), behavior: 'smooth' });
    }
  });

  var chips = $$('[data-pz-chip]');
  function applyChip(g) {
    chips.forEach(function (c) { c.classList.toggle('is-on', c.dataset.pzChip === g); });
    var shown = 0;
    $$('.pz-grid[data-pz-main] .pz-card').forEach(function (c) {
      var ok = g === 'all' || c.dataset.grade === g; c.style.display = ok ? '' : 'none'; if (ok) shown++;
    });
    var none = $('[data-pz-none]'); if (none) none.style.display = shown ? 'none' : 'block';
    $$('[data-pz-shown]').forEach(function (n) { n.textContent = shown; });
  }
  if (chips.length) {
    chips.forEach(function (c) { c.addEventListener('click', function () { applyChip(c.dataset.pzChip); history.replaceState(null, '', c.dataset.pzChip === 'all' ? location.pathname + location.search : '#grade-' + c.dataset.pzChip); }); });
    var m = location.hash.match(/grade-(new|a|b|c)/); if (m) applyChip(m[1]);
  }
  $$('[data-pz-view]').forEach(function (b) {
    b.addEventListener('click', function () {
      var g = $('.pz-grid[data-pz-main]'); if (!g) return;
      g.classList.toggle('is-list', b.dataset.pzView === 'list');
      $$('[data-pz-view]').forEach(function (x) { x.classList.toggle('is-on', x === b); });
    });
  });
  var sortSel = $('[data-pz-sort]');
  if (sortSel) sortSel.addEventListener('change', function () { var u = new URL(location.href); u.searchParams.set('sort_by', sortSel.value); u.searchParams.delete('page'); location.href = u.toString(); });
  var more = $('[data-pz-more]');
  if (more) more.addEventListener('click', function (e) {
    e.preventDefault(); more.disabled = true; var label = more.innerHTML; more.textContent = 'Loading…';
    fetch(more.dataset.href).then(function (r) { return r.text(); }).then(function (html) {
      var d = new DOMParser().parseFromString(html, 'text/html'), g = $('.pz-grid[data-pz-main]');
      $$('.pz-grid[data-pz-main] .pz-card', d).forEach(function (c) { g.appendChild(document.importNode(c, true)); });
      var nx = $('[data-pz-more]', d);
      if (nx) { more.dataset.href = nx.dataset.href; more.disabled = false; more.innerHTML = label; } else more.parentNode.remove();
      var cur = chips.filter(function (c) { return c.classList.contains('is-on'); })[0]; if (cur) applyChip(cur.dataset.pzChip);
      wsync();
    }).catch(function () { more.disabled = false; more.innerHTML = label; });
  });

  if (PZ.pjnLogoUrl) {
    fetch(PZ.pjnLogoUrl).then(function (r) { return r.text(); }).then(function (t) { pjnLogoCache = t; }).catch(function () { });
  }

  var pdp = $('[data-pz-pdp]');
  if (pdp) {
    var vdata = $('[data-pz-variants]', pdp), variants = vdata ? JSON.parse(vdata.textContent) : [];
    var form = $('[data-pz-form]', pdp), idIn = $('[name=id]', form), addBtn = $('[data-pz-submit]', pdp);
    function selected() { return $$('[data-pz-opt]:checked', pdp).map(function (i) { return i.value; }); }
    function onVariant() {
      var sel = selected(), v = variants.filter(function (x) { return sel.every(function (s, k) { return x.options[k] === s; }); })[0];
      if (!v) { addBtn.disabled = true; addBtn.querySelector('span').textContent = 'Unavailable'; return; }
      idIn.value = v.id;
      $$('[data-pz-price]', pdp).forEach(function (p) { p.textContent = money(v.price); });
      var cmp = $('[data-pz-compare]', pdp); if (cmp) { cmp.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : ''; cmp.style.display = v.compare_at_price > v.price ? '' : 'none'; }
      var fw = $('[data-pz-finwrap]', pdp); if (fw) { var fb = fw.querySelector('[data-force]'); fw.innerHTML = finBoxHtml(v.price, fb ? fb.dataset.force : ''); }
      addBtn.disabled = !v.available; addBtn.querySelector('span').textContent = v.available ? 'Add to cart' : 'Sold out';
      if (v.featured_image) { var mi = $('[data-pz-mainimg]', pdp); if (mi) { mi.src = v.featured_image; mi.dataset.big = v.featured_image; } }
      var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u);
    }
    $$('[data-pz-opt]', pdp).forEach(function (i) {
      i.addEventListener('change', function () {
        var y = window.scrollY;
        var until = performance.now() + 600;
        var hold = function () {
          if (Math.abs(window.scrollY - y) > 1) window.scrollTo(0, y);
          if (performance.now() < until) requestAnimationFrame(hold);
        };
        onVariant();
        requestAnimationFrame(hold);
      });
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var props = {};
      if (form.dataset.condition) props.Condition = form.dataset.condition;
      if (form.dataset.battery) props['Battery Health'] = form.dataset.battery;
      addToCart(idIn.value, Object.keys(props).length ? props : null, addBtn);
    });
    var thumbs = $$('[data-pz-thumb]', pdp), mainImg = $('[data-pz-mainimg]', pdp), idx = 0;
    function show(n) {
      if (!thumbs.length) return; idx = (n + thumbs.length) % thumbs.length;
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === idx); });
      mainImg.src = thumbs[idx].dataset.src; mainImg.dataset.big = thumbs[idx].dataset.big;
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
    $$('[data-pz-gal]', pdp).forEach(function (b) { b.addEventListener('click', function (e) { e.stopPropagation(); show(idx + +b.dataset.pzGal); }); });
    var main = $('[data-pz-zoom]', pdp);
    if (main) main.addEventListener('click', function () {
      var lb = $('.pz-lb');
      if (!lb) { lb = document.createElement('div'); lb.className = 'pz-lb'; lb.innerHTML = '<img alt="">'; lb.addEventListener('click', function () { lb.classList.remove('is-on'); }); document.body.appendChild(lb); }
      $('img', lb).src = mainImg.dataset.big || mainImg.src; lb.classList.add('is-on');
    });

    var recBox = $('[data-pz-accessory-recs]', pdp);
    if (recBox) {
      var recPid = recBox.dataset.productId;
      var recList = $('[data-pz-setup-list]', recBox);
      if (recPid && recList) {
        fetch('/recommendations/products.json?product_id=' + encodeURIComponent(recPid) + '&intent=complementary&limit=10')
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (j) {
            if (!j || !j.products || !j.products.length) return;
            var rank = {};
            j.products.forEach(function (u, k) { rank[String(u.id)] = k; });
            var cards = $$('.pz-mc', recList);
            var matched = cards.filter(function (c) { return rank.hasOwnProperty(c.dataset.id); });
            if (!matched.length) return;
            matched.sort(function (a, b) { return rank[a.dataset.id] - rank[b.dataset.id]; });
            var rest = cards.filter(function (c) { return !rank.hasOwnProperty(c.dataset.id); });
            matched.concat(rest).forEach(function (c) { recList.appendChild(c); });
          })
          .catch(function () {});
      }
    }

    var tabBtns = $$('[data-pz-tab]', pdp);
    var tabTargets = tabBtns.map(function (b) { return document.getElementById(b.dataset.pzTab); }).filter(Boolean);
    tabBtns.forEach(function (b) {
      b.addEventListener('click', function () { var t = document.getElementById(b.dataset.pzTab); if (t) t.scrollIntoView({ behavior: 'smooth' }); });
    });
    if (tabTargets.length) {
      var tabnav = $('.pz-tabnav', pdp);
      var syncTabs = function () {
        var edge = tabnav ? tabnav.getBoundingClientRect().bottom : 140;
        var current = tabTargets[0];
        tabTargets.forEach(function (t) { if (t.getBoundingClientRect().top - edge <= 0) current = t; });
        tabBtns.forEach(function (b) { b.classList.toggle('is-on', document.getElementById(b.dataset.pzTab) === current); });
      };
      var tTick = false;
      window.addEventListener('scroll', function () { if (!tTick) { tTick = true; requestAnimationFrame(function () { syncTabs(); tTick = false; }); } }, { passive: true });
      window.addEventListener('resize', syncTabs);
      syncTabs();
    }
  }
})();